// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__R6J3K","title":"card_title__2QcJP","inActive":"card_inActive__3K6I7"};